(() => {
  if (window.PS26ProductSystem) return;
  window.PS26ProductSystem = true;

  const selectors = {
    bundle: '[data-ps26-bundle]',
    quantity: '[data-ps26-quantity]',
    sticky: '[data-ps26-sticky]',
    stickyPrice: '[data-ps26-sticky-price]',
    stickyQuantity: '[data-ps26-sticky-quantity]',
    stickySubmit: '[data-ps26-sticky-submit]',
    stickyLabel: '[data-ps26-sticky-label]',
    stickyVariant: '[data-ps26-sticky-variant]',
    primaryBuy: '[data-ps26-buy]',
  };

  const formatMoney = (cents, format) => {
    const value = Number(cents || 0);
    const cleanFormat = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    const token = cleanFormat.match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
    const useDecimals = !token.includes('no_decimals');
    const decimalMark = token.includes('comma_separator') ? ',' : '.';
    const thousandsMark = decimalMark === ',' ? '.' : ',';
    const number = (value / 100).toFixed(useDecimals ? 2 : 0);
    const [whole, decimals] = number.split('.');
    const grouped = whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousandsMark);
    const amount = useDecimals ? `${grouped}${decimalMark}${decimals}` : grouped;
    return cleanFormat.replace(/\{\{\s*\w+\s*\}\}/, amount);
  };

  const syncQuantity = (quantity) => {
    const safeQuantity = Math.max(1, Number.parseInt(quantity, 10) || 1);
    document.querySelectorAll(selectors.quantity).forEach((input) => {
      input.value = safeQuantity;
    });
    document.querySelectorAll(selectors.stickyQuantity).forEach((input) => {
      input.value = safeQuantity;
    });
  };

  const updateStickyVariant = (variant) => {
    if (!variant) return;

    document.querySelectorAll(selectors.sticky).forEach((sticky) => {
      const idInput = sticky.querySelector(selectors.stickyVariant);
      const submit = sticky.querySelector(selectors.stickySubmit);
      const label = sticky.querySelector(selectors.stickyLabel);
      const price = sticky.querySelector(selectors.stickyPrice);

      if (idInput) {
        idInput.value = variant.id;
        idInput.disabled = !variant.available;
      }
      if (submit) submit.disabled = !variant.available;
      if (label) {
        label.textContent = variant.available
          ? sticky.dataset.availableLabel
          : sticky.dataset.soldOutLabel;
      }
      if (price) {
        price.textContent = formatMoney(variant.price, sticky.dataset.moneyFormat);
      }
    });
  };

  const initBundles = (root = document) => {
    root.querySelectorAll(selectors.bundle).forEach((button) => {
      if (button.dataset.ps26Ready) return;
      button.dataset.ps26Ready = 'true';
      button.addEventListener('click', () => {
        document.querySelectorAll(selectors.bundle).forEach((item) => {
          item.classList.toggle('is-selected', item === button);
          item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
        });
        syncQuantity(button.dataset.quantity);
      });
    });

    root.querySelectorAll(selectors.quantity).forEach((input) => {
      if (input.dataset.ps26Ready) return;
      input.dataset.ps26Ready = 'true';
      input.addEventListener('change', () => syncQuantity(input.value));
    });
  };

  const initSticky = (root = document) => {
    root.querySelectorAll(selectors.sticky).forEach((sticky) => {
      if (sticky.dataset.ps26Ready) return;
      sticky.dataset.ps26Ready = 'true';

      const buyArea = document.querySelector(selectors.primaryBuy);
      if (!buyArea || !('IntersectionObserver' in window)) {
        const revealAfterScroll = () => {
          sticky.hidden = window.scrollY < 600;
        };
        revealAfterScroll();
        window.addEventListener('scroll', revealAfterScroll, { passive: true });
        return;
      }

      const observer = new IntersectionObserver(
        ([entry]) => {
          sticky.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        },
        { threshold: 0 }
      );
      observer.observe(buyArea);
    });
  };

  const init = (root = document) => {
    initBundles(root);
    initSticky(root);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
      updateStickyVariant(payload?.data?.variant || payload?.variant);
    });
  }

  document.addEventListener('variant:change', (event) => {
    updateStickyVariant(event.detail?.variant);
  });
})();
